export const JOB_TYPE = {
  SCHOOL_LEAVER: 'N',
  EXPERIENCED: 'Y'
}

export const ROLE_TYPE = {
  FULL_TIME: 'F',
  PART_TIME: 'P',
  INTERNSHIP: 'I'
}

export const DEGREE = {
  OTHERS: 'Others',
  JUNIOR_SCHOOL: 'Junior School',
  HIGH_SCHOOL: 'High School',
  SECONDARY_TECHNICAL_SCHOOL: 'Secondary Technical School',
  JUNIOR_COLLEGE: 'Junior College',
  GRADUATE: 'Graduate',
  BACHELOR: 'Bachelor',
  MASTER: 'Master',
  PHD: 'PHD'
}

export const LANGUAGE = {
  ARABIC: 'ARA',
  CANTONESE: 'CAN',
  ENGLISH: 'ENG',
  FRENCH: 'FRN',
  GERMAN: 'GER',
  HINDI_OR_URDU: 'HIN',
  ITALIAN: 'ITA',
  JAPANESE: 'JAP',
  KOREAN: 'KOR',
  MANDARIN: 'MAN',
  RUSSIAN: 'RUS',
  SPANISH: 'SPA',
  TAMIL: 'TAM',
  MALAY: 'MAL',
  BURMESE: 'BUR',
  KHMER: 'KHM',
  TETUM: 'TET',
  PORTUGUESE: 'POR',
  INDONESIAN: 'IND',
  LAO: 'LAO',
  BENGALI: 'BEN',
  FILIPINO: 'FIL',
  THAI: 'THA',
  VIETNAMESE: 'VIE',
  SINHALESE: 'SIN'
}

export const LANGUAGE_LEVEL = {
  NATIVE: 'NAT',
  FLU: 'FLU',
  SCC: 'SCC',
  LIT: 'LIT',
  BAS: 'BAS'
}

export const CERTIFICATION = {
  CET4: 'CE4',
  CET6: 'CE6',
  TEM4: 'TE4',
  TEM8: 'TE8',
  PETS1: 'PETS1',
  PETS2: 'PETS2',
  PETS3: 'PETS3',
  PETS4: 'PETS4',
  PETS5: 'PETS5',
  TOEFL: 'TOEFL',
  IELTS: 'IELTS',
  OTHER: 'other'
}

export const CHAT_TOOL = {
  QQ: 'qq',
  ALWW: 'alww',
  FLY_XIN: 'flyxin',
  LINE: 'line',
  MI_LIAO: 'miliao',
  MO_MO: 'momo',
  MSN: 'msn',
  PAPA: 'papa',
  SKYPE: 'skype',
  TM: 'tm',
  YY: 'yy'
}

export const SOCIAL_NETWORK = {
  BAI_DU_TIE_BA: 'bdtb',
  BLOG: 'blog',
  DOU_BAN: 'douban',
  FACEBOOK: 'facebook',
  KAIXIN: 'kaixin',
  LINKEDIN: 'linkedin',
  MOP: 'mop',
  QQ_ZONE: 'qzone',
  REN_REN: 'renren',
  SOHU_WEI_BO: 'shwb',
  TIANYA: 'tianya',
  TWITTER: 'twitter',
  TENCENT_WEI_BO: 'txwb',
  WEICHAT: 'weixin',
  SINA_WEI_BO: 'xlwb'
}
